import React from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../CustomButton';
import { formatVehicleName, formatTimestamp, formatViewEvent } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const EventsMobileCard = ({ row, editVehicle }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });
	const navigate = useNavigate();

	const nameLabel = formatVehicleName(row.device_id, row);

	const baseData = [
		{ label: t('Type'), value: row.type },
		{ label: t(('Date/Time').replace(/\s/g, '_')), value: row.timestamp ? formatTimestamp(`${row.timestamp}+00`) : '-' },
	];

	const viewEventLink = formatViewEvent(row.event_id, row, navigate);

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
				{!!viewEventLink && (
					<div className="asset-log-links">
						<div className="mobile-card-data-item">
							{viewEventLink}
						</div>
					</div>
				)}
			</Card.Body>
		</Card>
	);
};

export default EventsMobileCard;
